module.exports = __webpack_public_path__ + "img/home.737245b7.svg";